import { checkNumber, stringCount } from './index';
import { rateLabels } from './rate';

export const formatByte = (input: null | undefined | number | string): string => {
    if (input === null || input === undefined) {
        return '0';
    }
    const num = typeof input === 'number' ? input : Number(input.replace(/\s+/g, ''));
    if (!Number.isFinite(num) || num <= 0) {
        return '0';
    }
    return Math.floor(num)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
};

export const byteSignificantDigits = (byte: any, divider = 1000, decimal = 0): string => {
    return range(byte, divider, decimal, rateLabels.bytes);
};

export const range1000 = (byte: any, decimal = 3, labels?: string[]): string => {
    return range(byte, 1000, decimal, labels);
};

export const moneyRange = (cost: any, label = rateLabels.short.slice(0, 5)): string => {
    return range(cost, 1000, 0, label);
};

export const smsRange = (value: any): string => {
    return `${range(value, 1000, 0, rateLabels.symbol)} sms`;
};

export function formatBytesIntegerOnly(byte: number | null | undefined, divider = 1000): string {
    if (!byte || byte <= 0) {
        return `0 ${rateLabels.bytes[0]}`;
    }

    let size = byte;
    let index = 0;

    while (size % divider === 0 && size >= divider && index < rateLabels.bytes.length - 1) {
        size = size / divider;
        index++;
    }

    return `${size} ${rateLabels.bytes[index]}`;
}

export const range = (value: any, divider = 1000, decimal = 0, labels = rateLabels.short): string => {
    let prefix = '';
    let newValue = checkNumber(value);
    if (newValue < 0) {
        prefix = '-';
        newValue = newValue * -1;
    }
    let range = 0;
    while (newValue / divider > 1 && range < labels.length - 1) {
        newValue = newValue / divider;
        range++;
    }
    newValue = Math.round(newValue * 10 ** decimal) / 10 ** decimal;
    const label = range > labels.length - 1 ? labels[labels.length - 1] : labels[range];
    return `${prefix}${stringCount(newValue, decimal)} ${label}`;
};

export const minutesRange = (seconds: any = 0): string => {
    const checkedSeconds = checkNumber(seconds);

    if (checkedSeconds < 60) {
        return `${seconds} sec`;
    }

    return `${range(checkNumber(seconds) / 60, 1000, 0, rateLabels.short)} min`;
};
